import { useEffect } from 'react'

/**
 * iOS Safari's 100vh / position:fixed inset:0 sit under the URL + tab bars.
 * Pin overlay chrome to visualViewport so sheets, camera, and mint actions stay on-screen.
 */
export const VisualViewportCss = () => {
  useEffect(() => {
    const sync = () => {
      const root = document.documentElement
      const vv = window.visualViewport
      const height = vv?.height ?? window.innerHeight
      const top = vv?.offsetTop ?? 0
      root.style.setProperty('--mem-vv-height', `${Math.round(height)}px`)
      root.style.setProperty('--mem-vv-top', `${Math.round(top)}px`)
    }

    sync()
    window.visualViewport?.addEventListener('resize', sync)
    window.visualViewport?.addEventListener('scroll', sync)
    window.addEventListener('orientationchange', sync)
    window.addEventListener('resize', sync)

    return () => {
      window.visualViewport?.removeEventListener('resize', sync)
      window.visualViewport?.removeEventListener('scroll', sync)
      window.removeEventListener('orientationchange', sync)
      window.removeEventListener('resize', sync)
    }
  }, [])

  return null
}
